<template>
  <v-dialog
    v-model="modalData.dialog"
    max-width="1450px"
    persistent
    scrollable
    :retain-focus="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="permissionCan('create')"
        color="primary"
        dark
        class="mb-2"
        v-bind="attrs"
        v-on="on"
        @click="$emit('new')"
      >
        {{ $t("MENU.NEW") }} {{ $t("MENU.POPUP") }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <span class="headline">{{ formTitle }} </span>
            <v-btn @click="handleCloseModalForm" icon class="close-button">
              <v-icon> mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid" ref="form">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2" md="2">
              <v-select
                v-model="selectedLocale"
                :items="languages"
                :disabled="languages.length == 1"
              >
                <template slot="selection" slot-scope="slotProps">
                  <span class="symbol symbol-20 mr-3">
                    <img :src="selectedLocale.flag" alt="" />
                  </span>
                  {{ slotProps.item.name }}
                </template>
                <template v-slot:item="slotProps">
                  <span class="symbol symbol-20 mr-3">
                    <img :src="slotProps.item.flag" alt="" />
                  </span>
                  <span class="navi-text">{{ slotProps.item.name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-select
                v-if="statuses.popups"
                v-model="formModel.status"
                :items="statuses.popups.popup_category"
                :label="$t('FORMS.status')"
                item-text="value"
                item-value="key"
              >
                <template slot="selection" slot-scope="slotProps">
                  {{ $t("STATUSES." + slotProps.item.value) }}
                </template>
                <template v-slot:item="slotProps">
                  <span class="navi-text">{{
                    $t("STATUSES." + slotProps.item.value)
                  }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-spacer></v-spacer>
            <CustomFieldComponent
              v-if="
                formModel.translations[selectedLocale.lang] &&
                formModel.translations[selectedLocale.lang].custom_fields
              "
              customFieldName="dateRange"
              :config="{
                type: 'date_range_picker',
                label: 'FORM_INPUT_NAMES.dateRange',
                selectButtonText: 'FORM_INPUT_NAMES.mobile_image',
                initialColumnClass:
                  'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12',
              }"
              :value="
                formModel.translations[selectedLocale.lang].custom_fields
                  .dateRange || ''
              "
              @handleChangeCustomFieldValue="handleChangeCustomFieldValue"
            >
            </CustomFieldComponent>
          </v-row> -->

          <v-row>
            <v-col cols="12" sm="6" md="3">
              <CustomFieldComponent
                v-if="
                  formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields
                "
                customFieldName="dateTimeFrom"
                :config="{
                  type: 'date_time_picker',
                  label: 'FORM_INPUT_NAMES.dateTimeFrom',
                }"
                :value="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .dateTimeFrom || ''
                "
                @handleChangeCustomFieldValue="handleChangeCustomFieldValue"
              >
              </CustomFieldComponent>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <CustomFieldComponent
                v-if="
                  formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields
                "
                customFieldName="dateTimeTo"
                :config="{
                  type: 'date_time_picker',
                  label: 'FORM_INPUT_NAMES.dateTimeTo',
                }"
                :value="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .dateTimeTo || ''
                "
                @handleChangeCustomFieldValue="handleChangeCustomFieldValue"
              >
              </CustomFieldComponent>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="8" md="8">
              <v-text-field
                v-if="formModel.translations[selectedLocale.lang]"
                v-model="formModel.translations[selectedLocale.lang].name"
                :key="selectedLocale.lang + '-name'"
                :rules="nameRules"
                :label="$t('FORMS.name')"
                :id="dynamicID"
                :error-messages="
                  messages['translations.' + selectedLocale.lang + '.name']
                "
                @keyup="
                  messages['translations.' + selectedLocale.lang + '.name'] = ''
                "
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <!-- <v-col cols="12" sm="2" md="2">
              <v-switch
                class="mt-5"
                v-model="formModel.exit_popup"
                :label="$t('FORM_INPUT_NAMES.exit_popup')"
              ></v-switch>
            </v-col> -->
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-radio-group
                :label="$t('FORM_INPUT_NAMES.popup_location')"
                v-model="popupLocation"
              >
                <v-radio
                  :label="$t('FORM_INPUT_NAMES.global')"
                  checked
                  >
                </v-radio>
                <v-radio
                  :label="$t('FORM_INPUT_NAMES.main_page_only')"
                  >
                </v-radio>
                <v-radio
                  :label="$t('FORM_INPUT_NAMES.selected_pages')"
                  >
                </v-radio>
              </v-radio-group>
              <CustomFieldComponent
                v-if="
                  formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields && 
                  popupLocation == 2
                "
                customFieldName="urls"
                :config="{
                  type: 'combo_box',
                  multiple: true,
                  label: 'FORM_INPUT_NAMES.urls'
                }"
                :value="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .urls || ''
                "
                @handleChangeCustomFieldValue="handleChangeCustomFieldValue"
              >
              </CustomFieldComponent>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-select
                v-if="
                  formModel &&
                  formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields
                "
                v-model="popupType"
                :items="[
                  {id: 1, text: 'Kép'}, 
                  {id: 2, text: 'Kép és szöveg'}
                ]"
                :label="$t('FORM_INPUT_NAMES.popup_type')"
                item-text="text"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12">
              <CustomFieldComponent
                v-if="
                  formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields
                "
                customFieldName="desctop_image"
                :config="{
                  type: 'media_selector',
                  maxFiles: 1,
                  inputFields: [
                    {
                      name: 'title',
                      label: 'FORM_INPUT_NAMES.title',
                      type: 'text',
                    },
                    {
                      name: 'description',
                      label: 'FORM_INPUT_NAMES.description',
                      type: 'text',
                    },
                    {
                      name: 'url',
                      label: 'FORM_INPUT_NAMES.url',
                      type: 'text',
                    },
                    {
                      name: 'alt_text',
                      label: 'FORM_INPUT_NAMES.alt_text',
                      type: 'text',
                    },
                  ],
                  selectButtonText: 'FORM_INPUT_NAMES.desktop_image',
                  initialColumnClass:
                    'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12',
                }"
                :value="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .desctop_image || ''
                "
                @handleChangeCustomFieldValue="handleChangeCustomFieldValue"
              >
              </CustomFieldComponent>

              <CustomFieldComponent
                v-if="
                  formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields
                "
                customFieldName="mobile_image"
                :config="{
                  type: 'media_selector',
                  maxFiles: 1,
                  inputFields: [
                    {
                      name: 'title',
                      label: 'FORM_INPUT_NAMES.title',
                      type: 'text',
                    },
                    {
                      name: 'description',
                      label: 'FORM_INPUT_NAMES.description',
                      type: 'text',
                    },
                    {
                      name: 'url',
                      label: 'FORM_INPUT_NAMES.url',
                      type: 'text',
                    },
                    {
                      name: 'alt_text',
                      label: 'FORM_INPUT_NAMES.alt_text',
                      type: 'text',
                    },
                  ],
                  selectButtonText: 'FORM_INPUT_NAMES.mobile_image',
                  initialColumnClass:
                    'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12',
                }"
                :value="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .mobile_image || ''
                "
                @handleChangeCustomFieldValue="handleChangeCustomFieldValue"
              >
              </CustomFieldComponent>
            </v-col>
          </v-row>
          <v-row 
            v-if="formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields && 
                  popupType == 2">
            <v-col cols="12">
              <v-text-field
                v-model="formModel.translations[selectedLocale.lang].custom_fields.title"
                :label="$t('FORMS.title')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row 
            v-if="formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields && 
                  popupType == 2">
            <v-col cols="12">
              {{ $t("FORMS.text") }}
              <ckeditor
                v-model="formModel.translations[selectedLocale.lang].custom_fields.text"
                
                :error-messages="
                  messages['translations.' + selectedLocale.lang + '.custom_fields.text']
                "
                @input="
                  messages['translations.' + selectedLocale.lang + '.custom_fields.text'] = ''
                "
                :config="editorConfig"
              ></ckeditor>
              <small
                v-if="messages['translations.' + selectedLocale.lang + '.custom_fields.text']"
                style="color: red"
              >
                {{ messages["translations." + selectedLocale.lang + ".custom_fields.text"] }}
              </small>
            </v-col>
          </v-row>
          <v-row v-if="formModel.translations[selectedLocale.lang] &&
                  formModel.translations[selectedLocale.lang].custom_fields && 
                  popupType == 2">
            <v-col cols="12" sm="5" md="5">
              <v-text-field
                v-model="
                  formModel.translations[selectedLocale.lang].custom_fields.button_text
                "
                :label="$t('FORM_INPUT_NAMES.button_text')"
                :id="dynamicID"
                :error-messages="
                  messages[
                    'translations.' + selectedLocale.lang + '.button_text'
                  ]
                "
                @keyup="
                  messages[
                    'translations.' + selectedLocale.lang + '.button_text'
                  ] = ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <v-text-field
                v-model="formModel.translations[selectedLocale.lang].custom_fields.button_url"
                :label="$t('FORM_INPUT_NAMES.url')"
                :id="dynamicID"
                :error-messages="
                  messages['translations.' + selectedLocale.lang + '.custom_fields.button_url']
                "
                @keyup="
                  messages['translations.' + selectedLocale.lang + '.custom_fields.button_url'] = ''
                "
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="2" md="2">
              <v-select
                v-model="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .button_target
                "
                :value="
                  formModel.translations[selectedLocale.lang].custom_fields
                    .button_target || 'self'
                "
                :items="[
                  { key: 'self', value: 'Self' },
                  { key: 'blank', value: 'Blank' },
                ]"
                :label="$t('FORMS.target')"
                item-text="value"
                item-value="key"
                :id="dynamicID"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="mb-2">
        <v-spacer></v-spacer>
        <!-- <v-btn color="primary" text @click="handleCloseModalForm">
          {{ $t("FORMS.cancel") }}
        </v-btn> -->
        <v-btn
          v-if="
            (permissionCan('create') && !formModel.id) ||
            permissionCan('update')
          "
          color="primary"
          elevation="2"
          @click="handleSaveModalForm"
        >
          {{ $t("FORMS.save") }}
        </v-btn>
      </v-card-actions>
      <SnackBarInfoComponent :snackbarInfo="snackbarInfo">
      </SnackBarInfoComponent>
    </v-card>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import { PERMISSION_TO } from "./Popups";
import i18nService from "@/core/services/i18n.service.js";
import ApiService from "@/core/services/api.service";
import CustomFieldComponent from "@/view/components/CustomFieldComponent";
import { formModelMixins } from "@/view/mixins/formModelMixins.js";
import { customFieldMixins } from "@/view/mixins/customFieldMixins.js";
import SnackBarInfoComponent from "@/view/components/SnackBarInfoComponent";

const TRANSLATED_ATRIBUTES = ["name"];

export const INITIAL_TRANSLATED_CUSTOM_FIELDS = [
  "desctop_image",
  "mobile_image",
  "dateTimeFrom",
  "dateTimeTo",
  "title",
  "text",
  "button_text",
  "button_url",
  "button_target",
  "popup_type",
  "global",
  "main_page",
  "urls"
];

export const initialFormData = () => ({
  status: 1,
  translations: {},
  // custom_fields: [],
});

export default {
  name: "PopupForm",
  props: ["modalData", "permissions", "statuses", "endPoint"],
  components: {
    CustomFieldComponent,
    SnackBarInfoComponent,
  },
  mixins: [formModelMixins, customFieldMixins],
  data() {
    return {
      result: null,
      languages: i18nService.userLanguages,
      selectedLocale: i18nService.userLanguages.find((item) => {
        return item.lang == i18nService.getUserActiveLanguage();
      }),
      formModel: Object.assign({}, initialFormData()),
      formValid: false,
      permissionTo: PERMISSION_TO,
      initialTransaltedCustomFields: INITIAL_TRANSLATED_CUSTOM_FIELDS,
      popupType: 1,
      popupLocation: 0,
      messages: {},
      nameRules: [
        (v) => !!v || this.$t("ERRORS.field_is_required"),
        (v) =>
          (!!v && v.length < 250) || this.$t("ERRORS.must_be_max_characters"),
      ],
      requiredRules: [(v) => !!v || this.$t("ERRORS.field_is_required")],
      // editorConfig: {
      //   htmlEncodeOutput: false,
      //   entities: false,
      //   extraPlugins: "justify,font,copyformatting",
      //   filebrowserBrowseUrl:
      //     window.location.origin +
      //     "/" +
      //     this.$router.resolve({
      //       name: "media_library",
      //       query: { component_in_window: 1 },
      //     }).href +
      //     "?type=Files",
      //   filebrowserImageBrowseUrl:
      //     window.location.origin +
      //     "/" +
      //     this.$router.resolve({
      //       name: "media_library",
      //       query: { component_in_window: 1 },
      //     }).href +
      //     "?type=Images",
      // },
    };
  },
  computed: {
    // ...mapGetters([CURRENCY_COLLECTION]),
    dynamicID() {
      let text = "dynamicID";
      let chars = "abcdefghijklmnopqrstuvwxyz";

      for (let i = 0; i < 10; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return text;
    },

    formTitle() {
      return this.formModel.id
        ? this.$t("FORMS.edit") +
            this.$helpers.getTranslated(this.formModel.translations).name
        : this.$t("MENU.NEW") + " " + this.$t("MENU.POPUP");
    },

    translatedAttributes() {
      return TRANSLATED_ATRIBUTES;
    },
    initialFormData() {
      return initialFormData;
    },
  },
  watch: {
    modalData: {
      deep: true,
      handler(value) {
        this.selectedLocale = i18nService.userLanguages.find((item) => {
          return item.lang == i18nService.getUserActiveLanguage();
        });
        if (value.editedId) {
          this.loader = true;
          this.formModel = Object.assign({}, initialFormData());
          ApiService.get(this.endPoint + value.editedId)
            .then(({ data }) => {
              data.status = 1 * data.status;
              this.formModel = Object.assign({}, data);
              this.setTranslatedAttributes();
              // this.formModel.custom_fields = this.initCustomFields();
              this.popupType = this.formModel.translations[this.selectedLocale.lang].custom_fields.popup_type || 1;
              this.popupLocation = this.formModel.translations[this.selectedLocale.lang].custom_fields.global ? 0 : this.formModel.translations[this.selectedLocale.lang].custom_fields.main_page ? 1 : 2;
            })
            .catch((error) => {
              console.log("Error!: ", error);
            })
            .finally(() => {
              this.loader = false;
            });
        } else {
          this.formModel = Object.assign({}, initialFormData());
          this.setTranslatedAttributes();
          this.formModel.translations[this.selectedLocale.lang].custom_fields.popup_type = 1;

          // this.formModel.custom_fields = this.initCustomFields();
          if (this.$refs.form) this.$refs.form.resetValidation();
        }
        this.resetErrorMessages();
      },
    },
  },
  methods: {
    // ...mapActions([FETCH_CURRENCY]),
    handleSaveModalForm() {
      this.formModel.translations[this.selectedLocale.lang].custom_fields.popup_type = this.popupType;
      
      let model = this.deleteUnusedTranslations(
        Object.assign({}, this.formModel)
      );

      this.$refs.form.validate();

      this.setPopupLocations();

      if (this.formValid) {
        this.resetErrorMessages();
        this.loader = true;
        if (model.id) {
          ApiService.put(this.endPoint + model.id, model)
            .then(() => {
              this.showSnackBarInfo();
              this.$emit("saveModalForm");
            })
            .catch((error) => {
              if (error.response) {
                let errors = error.response.data;
                if (errors) {
                  for (let field in errors.errors) {
                    this.setError(field, errors.errors[field][0]);
                  }
                }
              }
            })
            .finally(() => {
              this.loader = false;
            });
        } else {
          //create model
          console.log('before post', model);
          ApiService.post(this.endPoint, model)
            .then(({ data }) => {
              console.log('after post', model);
              this.showSnackBarInfo();
              this.$emit("saveModalForm", data);
            })
            .catch((error) => {
              if (error.response) {
                let errors = error.response.data;
                if (errors) {
                  for (let field in errors.errors) {
                    this.setError(field, errors.errors[field][0]);
                  }
                  console.log(this.messages);
                }
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
              }
              console.log("Error!: ", error);
              // this.modalData.loading = false;
            })
            .finally(() => {
              this.loader = false;
            });
        }
      }
    },

    setPopupLocations() {
      if (this.popupLocation === 0) {
        this.formModel.translations[this.selectedLocale.lang].custom_fields.global = 1;
        this.formModel.translations[this.selectedLocale.lang].custom_fields.main_page = 0;
        this.formModel.translations[this.selectedLocale.lang].custom_fields.urls = [];
      } else if (this.popupLocation === 1) {
        this.formModel.translations[this.selectedLocale.lang].custom_fields.global = 0;
        this.formModel.translations[this.selectedLocale.lang].custom_fields.main_page = 1;
        this.formModel.translations[this.selectedLocale.lang].custom_fields.urls = [];
      } else if (this.popupLocation === 2) {
        this.formModel.translations[this.selectedLocale.lang].custom_fields.global = 0;
        this.formModel.translations[this.selectedLocale.lang].custom_fields.main_page = 0;
      }
    }

    // Let dateTimeFrom and dateTimeTo be null if no date is selected
    // messes up the saving of the CustomfieldComponent!
    /* handleChangeCustomFieldValue(cfname, val) {
      if (cfname === 'dateTimeFrom') {
        this.formModel.translations[this.selectedLocale.lang].custom_fields.dateTimeFrom = val;
      } else if (cfname === 'dateTimeTo') {
        this.formModel.translations[this.selectedLocale.lang].custom_fields.dateTimeTo = val;
      }
    } */
  },

  mounted() {
    this.setTranslatedAttributes();
  },
};
</script>

<style scoped>
  ::v-deep .v-radio label {
    margin-bottom: 0;
  }
</style>